import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/devices')({
  staticData: { breadcrumb: 'Devices' },
  component: () => <Outlet />,
});
